import React, { useRef, useState } from "react";
import "../../../StyleSheet/MainComponent/LoginPage/forgotPassword.scss";
import Email from "../../AppComponent/InputFields/Email";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import Password from "../../AppComponent/InputFields/Password";
import validator from "validator";
import { useDispatch, useSelector } from "react-redux";
import {
  forgotOtp,
  getForgotUserAction,
  getUserAction,
  getVerifyOtpUserAction,
} from "../../../Redux/Slice";
import logo from "../../../Assets/AppComponent/Logo/Group 56.png";
import toppart from "../../../Assets/AppComponent/TopPartImg/Vector.png";
import Arrow from "../../../Assets/AppComponent/Arrow/Frame.png";
import data from "../../../Context/Json/Language/English";
import { useNavigate } from "react-router-dom";
import Number from "../../AppComponent/InputFields/Number";
import { FaLongArrowAltLeft } from "react-icons/fa";

const VerifyOtp = (props) => {
  const EnglishData = data;

  const inputRefs = useRef([]);

  const forgotUsers = useSelector(
    (state) => state?.forgotUsers?.UserData?.data,
  );
  const navigate = useNavigate();
  const [otp, setOtp] = useState(new Array(6).fill(""));

  const Datas = {
    otp: "",
    user: forgotUsers?.user,
    navigate,
  };
  const verifyOtpUser = useSelector((state) => state?.verifyOtpUser);
  console.log(verifyOtpUser, "daskldklalkdkla");

  const [InputData, setInputDatas] = useState(Datas);
  const [EmailError, setEmailError] = useState("");

  const [PasswordError, setPasswordError] = useState("");
  // const [isvalid, setvalid] = useState(true);
  // const [validateType, setValidatetype] = useState(null);
  const HandleChanges = (e) => {
    setInputDatas((prev) => {
      return {
        ...prev,
        ["otp"]: e.target.value,
      };
    });
  };
  const dispatch = useDispatch();
  const handleSubmit = (e) => {
    const enteredOtp = otp.join("");
    console.log(enteredOtp, "jdasjkajkdjka");
    e.preventDefault();
    var a = 0;
    if (enteredOtp.length !== 6) {
      setEmailError("*Please Enter OTP");
      a = 1;
    }
    if (a === 0) {
      console.log(InputData, "dakjdjkakjda");
      dispatch(forgotOtp(enteredOtp));
      dispatch(
        getVerifyOtpUserAction({
          otp: enteredOtp,
          user: forgotUsers?.user,
          navigate,
        }),
      );
    }
  };
  const handleChange = (element, index) => {
    const value = element.value.replace(/[^0-9]/g, "");
    if (value) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (index < 5 && inputRefs.current[index + 1]) {
        inputRefs.current[index + 1].focus();
      }
      console.log(value, "aksldlkadlka");
    }
  };
  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);

      if (index > 0 && !otp[index]) {
        inputRefs.current[index - 1].focus();
      }
    }
  };
  console.log(otp, "daskjdjakjkadjka");
  const handleClick = (index) => {
    const firstEmptyIndex = otp.findIndex((digit) => digit === "");
    if (firstEmptyIndex !== -1 && inputRefs.current[firstEmptyIndex]) {
      inputRefs.current[firstEmptyIndex].focus();
    }
  };

  return (
    <>
      <div className="uds-loginpage ">
        <div className=" row Conatiningpart">
          <div className="col-md-6 Welcomepart">
            <div className="Toppart">
              <img className="desingimg" src={toppart} alt="bgImage" />
            </div>
            <div className="bottompart">
              <div className="leftSidepart">
                <div className="Logo">
                  <img className="logoUds" src={logo} />
                </div>
                <div className="Content">
                  <h1>Welcome</h1>
                </div>
                {/* {EnglishData.LeftSide.Content.Content.map((item) => ( */}
                <p>Verify OTP in to continue</p>
                {/* ))} */}
                {EnglishData.LeftSide.Content2.map((item) => (
                  <div className="para">
                    {/* <p>{item.para2}</p> */}
                    <p>
                      {/* <strong>UDS :&nbsp;</strong> */}
                      Experience the future of business services with UDS.
                      Revolutionizing India's service landscape, we offer
                      integrated solutions for diverse sectors like never
                      before. From FMCG giants to cutting-edge IT firms, we've
                      got you covered.
                      {/* Your one-stop solution for
                      integrated business services across India. From facilities
                      management to diverse sector needs including FMCG,
                      healthcare, IT, logistics, and more. */}
                    </p>
                  </div>
                ))}

                {/* --------Details-------------------- */}
                <div className="Details">
                  {EnglishData.LeftSide.Details.Detail1.map((item) => (
                    <p key={item.id}>Enter Your Details</p>
                  ))}
                  <div className="Arrow">
                    <img src={Arrow} alt="bgArrow" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 loginpart">
            <div className="Loginwrapped">
              <div className="Udslog">
                {EnglishData.LeftSide.LoginPages.map((item) => (
                  <div className="forgotPasswordHeader">
                    <h4 className="heading" key={item.id}>
                      {/* {item.LoginHead} */}
                      Forgot Password
                    </h4>
                    <span>Please Enter OTP Received from Email</span>
                  </div>
                ))}
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="Input-Inner">
                    {/* {EnglishData.LeftSide.InputLabel.map((item) => ( */}
                    <>
                      <section className={"inputWrapper"}>
                        <label style={{ marginLeft: "1px" }}>OTP</label>
                        <div className={"otpFieldsWrapper"}>
                          {otp.map((digit, index) => (
                            <input
                              key={index}
                              type="text"
                              maxLength="1"
                              value={digit}
                              ref={(el) => (inputRefs.current[index] = el)}
                              className={"otpInput"}
                              onChange={(e) => handleChange(e.target, index)}
                              onKeyDown={(e) => handleKeyDown(e, index)}
                              onClick={() => handleClick(index)}
                            />
                          ))}
                        </div>
                      </section>
                      {/* <Email
                        value={InputData.otp}
                        onChange={(e) => {
                          setEmailError("");
                          HandleChanges(e);
                        }}
                        Error={EmailError}
                        label="OTP"
                        type={"number"}
                        //   isvalid={isvalid}
                        //   validateType={validateType}
                      /> */}
                      <span className="fortgotPassword">
                        <FaLongArrowAltLeft color="#f26639" />

                        <a
                          onClick={() => {
                            navigate("/forgotpassword");
                          }}
                        >
                          Back
                        </a>
                      </span>
                    </>
                  </div>
                  <div className="SubmitButton">
                    {EnglishData.LeftSide.Button.Button1.map((item) => (
                      <CustomButton
                        children="Submit"
                        //   onClick={handleSubmit}
                        type="submit"
                      >
                        Submit
                      </CustomButton>
                    ))}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyOtp;
